import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private http:HttpRequestService) { }
 
  GetCompPermssions(comp:string){
    return this.http.GetRequest('Permissions/compperms/'+comp);
  }
 





  
}
